import React from 'react';
import classnames from 'classnames';
import get from 'lodash/get';
import Duperswiper from '../_partials/Duperswiper';
import StageBackground from '../../DeviationBackground/StageBackground';
import CommissionPointsAndPrice from '../../CommissionPointsAndPrice';
import { getDeviationTitle } from '../../DeviationViews/_helpers';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import { formatDollars } from '../../utils/formatting';
import { useMobileStage } from '../hooks/useMobileStage';
import s from './CommissionMobileArtStage.scss';
var CommissionMobileArtStage = function (_a) {
    var className = _a.className, deviation = _a.deviation;
    var containerSize = useMobileStage(deviation).containerSize;
    var commission = deviation.commission;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classnames(className, s['root']), "data-hook": BiDataHook.DEVIATION_ART_STAGE },
            React.createElement(Duperswiper, { key: deviation.deviationId, deviation: deviation, height: get(containerSize, 'height'), width: get(containerSize, 'width') }, function (dev) { return React.createElement(StageBackground, { deviation: dev }); })),
        React.createElement("div", { className: s['title-and-price'] },
            React.createElement("h1", { className: s['title'] }, getDeviationTitle(deviation)),
            React.createElement("div", { className: s['price'] },
                React.createElement(CommissionPointsAndPrice, { points: commission.pointsCost, price: formatDollars(commission.dollarsCost) })))));
};
CommissionMobileArtStage.displayName = 'CommissionMobileArtStage';
export default CommissionMobileArtStage;
//# sourceMappingURL=CommissionMobileArtStage.js.map